import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { FNOLPATheftDetailsPage } from 'gwce-capability-fnol-pa-react-ext';
import React from 'react';
import { withRouter } from 'react-router-dom';

function FNOLCATheftDetailsPage(props) {
    return <FNOLPATheftDetailsPage {...props} />;

}

FNOLCATheftDetailsPage.propTypes = wizardProps;
export default withRouter(FNOLCATheftDetailsPage);
